import React from "react";
import StudentBulkUpload from "./components/StudentBulkUpload";
import EmployeeBulkUpload from "./components/EmployeeBulkUpload";
import ModeToggle from "../components/ModeToggle";
import little_image from "../Little_Logo150.png";
import "./BulkUpload.css";
import "../App.css";

const BulkUpload = ({ corpId, corpName, type = "Student", loadingGif }) => {
  // Handle mode toggle between individual and bulk registration
  const handleModeToggle = (isBulkMode) => {
    const currentUrl = new URL(window.location);
    const params = currentUrl.searchParams;

    if (isBulkMode) {
      params.set('bulk', 'true');
    } else {
      params.delete('bulk');
    }

    // Navigate to the new URL with updated parameters
    window.location.href = currentUrl.toString();
  };

  return (
    <div className="bulk-upload-wrapper">
      {/* Common Header with Mode Toggle */}
      <div className="header">
        <img src={little_image} alt="little pic" className="little-image" />
        <p className="student-header">
          {type === "Student" ? "STUDENT REGISTRATION" : "STAFF REGISTRATION"}
        </p>
        <ModeToggle
          isBulkMode={true}
          onToggle={handleModeToggle}
          disabled={false}
        />
      </div>

      {/* Conditional Rendering Based on Type */}
      {type === "Student" ? (
        <StudentBulkUpload
          corpId={corpId}
          corpName={corpName}
          loadingGif={loadingGif}
        />
      ) : (
        <EmployeeBulkUpload
          corpId={corpId}
          corpName={corpName}
          loadingGif={loadingGif}
        />
      )}
    </div>
  );
};

export default BulkUpload;